import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { finalize } from 'rxjs';

import { Project } from '../schemas';
import { Messenger } from '../service';
import { ProjectsService } from '../service/projects';

export interface RemoveProjectData {
  project: Project;
}

@Component({
  selector: 'lcm-remove-project-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule],
  template: `
    <h2 mat-dialog-title>Remove project</h2>
    <mat-dialog-content> Are you sure you want to remove the project "{{ data.project.Title }}"? </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="remove()">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
  styles: ``,
})
export class RemoveProjectDialog {
  projects = inject(ProjectsService);
  data = inject(MAT_DIALOG_DATA) as RemoveProjectData;
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);

  pending = signal(false);

  remove() {
    this.pending.set(true);
    this.projects
      .delete(this.data.project.Id)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => this.hostDialog.close(true),
        error: this.messenger.handleHttpError,
      });
  }
}
